export default __webpack_public_path__ + "static/mooniswap-42b68d85cb458e7d890280d470dc761c.jpg";